export default __webpack_public_path__ + "static/media/avrk_logo.12d15f1a.png";